import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b89499c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-100" }
const _hoisted_2 = { class: "has-text-white h-100 columns is-mobile" }
const _hoisted_3 = {
  key: 0,
  class: "column device-status is-1"
}
const _hoisted_4 = {
  key: 0,
  class: "mdi mdi-alert has-text-danger is-size-4 ml-1"
}
const _hoisted_5 = {
  key: 1,
  class: "mdi mdi-alert has-text-warning is-size-4 ml-1"
}
const _hoisted_6 = {
  key: 2,
  class: "mdi mdi-alert has-text-warning is-size-4 ml-1"
}
const _hoisted_7 = {
  key: 3,
  class: "mdi mdi-check has-text-success is-size-4"
}
const _hoisted_8 = { class: "column device-left p-0 is-5" }
const _hoisted_9 = { class: "has-text-weight-semibold device-name" }
const _hoisted_10 = { class: "is-size-6 has-text-grey-lighter" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-history is-size-6" }, null, -1 /* HOISTED */))
const _hoisted_12 = {
  key: 1,
  class: "column device-alarm is-4"
}
const _hoisted_13 = {
  key: 2,
  class: "column is-2 device-network"
}
const _hoisted_14 = { class: "has-text-weight-semibold" }
const _hoisted_15 = { class: "has-text-weight-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_ellipsis = _resolveComponent("n-ellipsis")!
  const _component_n_tooltip = _resolveComponent("n-tooltip")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    class: _normalizeClass(["device-item mb-3", {'has-gas-alarm': _ctx.hasGasAlarm && _ctx.showStatus, 'has-trouble-alarm': !_ctx.hasGasAlarm && _ctx.hasTroubleAlarm && _ctx.showStatus}]),
    to: { name: 'station-details', params: { station: _ctx.device.id, group: _ctx.device.group_name }, query: { since: _ctx.since.format(), before: _ctx.before.format() } }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.showStatus)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_ctx.hasGasAlarm)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4))
                  : (_ctx.hasTroubleAlarm)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5))
                    : (_ctx.isDeviceOffline)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6))
                      : (_openBlock(), _createElementBlock("span", _hoisted_7))
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_n_ellipsis, {
                style: {"width":"100%"},
                tooltip: true
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.device?.name), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              _createCommentVNode(" <span class=\"dot\" :class=\"{ 'is-success': device.status === 'online', 'is-danger': device.status === 'offline' }\"></span> ")
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createTextVNode(" " + _toDisplayString(_ctx.moment.unix(_ctx.device?.last_seen).fromNow()), 1 /* TEXT */)
            ])
          ]),
          (_ctx.showStatus)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alarms, (alarm) => {
                  return (_openBlock(), _createBlock(_component_n_tooltip, {
                    key: alarm,
                    trigger: "hover"
                  }, {
                    trigger: _withCtx(() => [
                      _createElementVNode("span", {
                        class: _normalizeClass(["is-size-4", alarm?.icon]),
                        style: _normalizeStyle({color: alarm?.name === 'CH4_concentration_alarm' ? _ctx.redColor : _ctx.orangeColor})
                      }, null, 6 /* CLASS, STYLE */)
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" " + _toDisplayString(alarm.short), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1024 /* DYNAMIC_SLOTS */))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true),
          (_ctx.showStatus)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                (_ctx.network)
                  ? (_openBlock(), _createBlock(_component_n_tooltip, {
                      key: 0,
                      trigger: "hover"
                    }, {
                      trigger: _withCtx(() => [
                        _createElementVNode("span", {
                          class: _normalizeClass(["is-size-5", _ctx.network.icon])
                        }, null, 2 /* CLASS */)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('station_table.quality')) + ": ", 1 /* TEXT */),
                        _createElementVNode("span", null, _toDisplayString(_ctx.network.label), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : (_openBlock(), _createBlock(_component_n_tooltip, {
                      key: 1,
                      trigger: "hover"
                    }, {
                      trigger: _withCtx(() => [
                        _createElementVNode("span", {
                          class: _normalizeClass(["is-size-5", _ctx.networkRepresentation[4]?.icon])
                        }, null, 2 /* CLASS */)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('station_table.quality')) + ": ", 1 /* TEXT */),
                        _createElementVNode("span", null, _toDisplayString(_ctx.networkRepresentation[4]?.label), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }))
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["class", "to"]))
}